module.exports = __webpack_public_path__ + "img/Foto_Press_Release_Efass.dda05f1d.jpeg";